export default {
    namespaced: true,    
    state: {
        obj: {},
        objs: [],
    },
    mutations: {
        setObjs(state, pload) {
            state.objs = pload
        },
        setObj(state, pload) {
            state.objs = pload
        },
    },
    actions: {
        getObj({rootState, commit}, _id){
            return new Promise((resolve, reject) => {
                let url = rootState.config.apiHost + "users/" + _id
                console.log(url)
                fetch (url, {method: 'get', headers: {'Authorization': 'Bearer '+ rootState.token, 'Content-Type': 'application/json'}})
                .then (response => response.json())
                .then (response => {
                    commit('setObj', response)
                    resolve(response)
                }, error => {
                    reject(error)
                })
            })
        },
        getObjs({rootState, commit}){
            return new Promise((resolve, reject) => {
                let url = rootState.config.apiHost + "users/"
                console.log(url)
                fetch (url, {method: 'get', headers: {'Authorization': 'Bearer '+ rootState.token, 'Content-Type': 'application/json'}})
                .then (response => response.json())
                .then (response => {
                    commit('setObjs', response)
                    resolve(response)
                }, error => {
                    reject(error)
                })
            })
        },
        postObj({rootState}, pload){
            return new Promise((resolve, reject) => {
                var url = rootState.config.apiHost + 'users/'
                console.log(url, pload)
                fetch(url, {method: 'post', body:JSON.stringify(pload), headers: {'Authorization': 'Bearer '+ rootState.token, 'Content-Type': 'application/json'}})
                .then(response => response.json())
                .then(response => {
                    console.log(response)
                    resolve(response)
                    // if (response.result)
                    //     resolve(response)
                    // else
                    //     reject(response)
                }, error => {
                    reject(error)
                });
            })
        },        

    },
}